var map = {
	"./black.png": 1019,
	"./blue.png": 1020,
	"./brown.png": 1021,
	"./gray.png": 1022,
	"./green.png": 1023,
	"./orange.png": 1024,
	"./pantone-logo.png": 717,
	"./pink.png": 1025,
	"./poc-spinner.png": 672,
	"./purple.png": 1026,
	"./red.png": 1027,
	"./white.png": 1028,
	"./yellow.png": 1029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 718;